export const API_URL = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_ENDPOINT || 'http://localhost:8000';
export const API_ENDPOINT = API_URL + "/api/v1";
